module.exports = __webpack_public_path__ + "img/鼎锐联仪表管理软件.9d18d30d.png";